import { Form } from "react-bootstrap";
import { Button } from "primereact/button";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../../stateManagement/hooks/redux";
import { applyCoordType } from "../../../../stateManagement/reducers/MapSlice";
import { setCopyCoordsTypeIsChosen } from "../../../../stateManagement/reducers/ContentHeaderSlice";

interface CopyWidgetProps {
    isCopyButtonTypeChosen: boolean;
}

const labelOptions: any = {
    decimal: 'Координаты в десятичном виде',
    degrees: 'Координаты в градусах, минутах и секундах',
    wktCoord: 'Координаты в формате WKT',
}

export const MapCopyCoordinatesWidget = ({isCopyButtonTypeChosen}: CopyWidgetProps) => {

    const dispatch = useDispatch()
    const coordsType = useAppSelector(state => state.map.coordsType)

    function applyCoordsType(key: string){
        dispatch(applyCoordType(key))
    }

    return (
        <>
            {!isCopyButtonTypeChosen && <div className="copyCoordTypePopUp">
                <p>Выберите формат координат для копирования</p>
                <ul>
                    {Object.keys(labelOptions).map((key => {
                        return (
                            <li key={key}>
                                <Form.Check >
                                    <Form.Check.Input
                                        className="map-checkbox"
                                        type="checkbox"
                                        id={`${key}`}
                                        checked={coordsType === `${key}`}
                                        onClick={() => applyCoordsType(key)}
                                    />
                                    <Form.Check.Label htmlFor={`${key}`}>{labelOptions[key]}</Form.Check.Label>
                                </Form.Check>
                            </li>
                        )
                    }))}
                </ul>
                <div className="d-flex">
                    <Button
                        className="apply-button"
                        severity="success"
                        size="small" 
                        onClick={() => { dispatch(setCopyCoordsTypeIsChosen(true)) }}
                    >
                        Применить
                    </Button>
                </div>
            </div>}
        </>
    )

}